import "./styles.css";

export const HorizontalLine = ({ type = "default" }) => {
  return <hr className={`horizontal-line-${type}`} />;
};
